import {Component, OnInit} from '@angular/core';
import {SuggestionListsService} from '../../../services/suggestion-lists.service';
import {ComponentBackgroundService} from '../../../../../../services/component-background.service';
import {UserService} from '../../../../../../services/user.service';
import { SortTableService } from '../../../../../../services/sort-table.service';
import { AppConstants } from '../../../../../views/view-user-profile/app.constants';

@Component({
  selector: 'app-my-sl-tab',
  templateUrl: './my-sl-tab.component.html',
  styleUrls: ['./my-sl-tab.component.css']
})
export class MySlTabComponent implements OnInit {

  private readonly STATUS_CANCELLED = 'CANCELLED';
  private readonly STATUS_IMPLEMENTED = 'IMPLEMENTED';

  isLoaded = false;
  mySLList: any[] = [];
  internalServerError = false;
  thisUser: any;
  
  currentPage = 0;
  pageSize = 10;
  totalPages = 0;
  totalElements = 0;
  
  mySLListActive: any[] = [];
  mySLListNotActive: any[] = [];
  
  create = true;
  redirect = false;
  
  isLoadingNextPage = false;

  constructor(public suggestionListsService: SuggestionListsService,
              public componentBackgroundService: ComponentBackgroundService,
              private userService: UserService,
              public sortTableService: SortTableService, ) {
  }

  sort(type) {
    const listToSort = this.create ? this.mySLListNotActive : this.mySLListActive;
    this.sortTableService.sortList('mySLList', listToSort, type, true);
  }

  ngOnInit() {
    this.resetLoadingState();
    this.loadUserAndSuggestions();
  }

  private resetLoadingState() {
    this.isLoaded = false;
    this.internalServerError = false;
  }

  private loadUserAndSuggestions() {
    const currentUser = this.userService.getLocal();
    if (currentUser && currentUser.id) {
      this.thisUser = currentUser;
      this.loadSuggestions();
      return;
    }

    this.userService.getSelf().subscribe(
      (res: any) => this.handleUserResponse(res),
      () => this.handleError()
    );
  }

  private handleUserResponse(res: any) {
    if (res.status === AppConstants.HTTP_STATUS.OK) {
      this.thisUser = res.body;
      this.loadSuggestions();
    } else {
      this.handleError();
    }
  }

  private handleError() {
    this.internalServerError = true;
    this.isLoaded = true;
  }

  loadSuggestions(page: number = 0) {
    this.prepareForLoading(page);
    
    this.suggestionListsService.getSLByUserIDWithPagination(
      this.thisUser.id, 
      page, 
      this.pageSize, 
      this.create 
    ).subscribe(
      (response: any) => this.handleSuggestionsResponse(response, page),
      (error) => this.handleSuggestionsError(error)
    );
  }

  private prepareForLoading(page: number) {
    this.isLoadingNextPage = true;
    this.currentPage = page;
  }

  private handleSuggestionsResponse(response: any, page: number) {
    if (response.status === AppConstants.HTTP_STATUS.OK) {
      this.processSuggestionsData(response.body, page);
      this.finishLoading(false);
    } else {
      this.finishLoading(true);
    }
  }

  private processSuggestionsData(pageResponse: any, page: number) {
    const newLists = (pageResponse && pageResponse.suggestions) ? pageResponse.suggestions : [];
    this.categorizeSuggestions(newLists);
    this.updatePaginationData(pageResponse, page);
  }

  private categorizeSuggestions(lists: any[]) {
    this.mySLListActive = [];
    this.mySLListNotActive = [];
    lists.forEach((item: any) => {
      if (item.status === this.STATUS_CANCELLED || item.status === this.STATUS_IMPLEMENTED) {
        this.mySLListActive.push(item);
      } else {
        this.mySLListNotActive.push(item);
      }
    });
  }

  private updatePaginationData(pageResponse: any, page: number) {
    this.currentPage = (pageResponse && pageResponse.currentPage !== undefined) ? pageResponse.currentPage : page;
    this.totalPages = (pageResponse && pageResponse.totalPages !== undefined) ? pageResponse.totalPages : 1;
    this.totalElements = (pageResponse && pageResponse.totalElements !== undefined) ? pageResponse.totalElements : 0;
  }

  private finishLoading(hasError: boolean) {
    this.internalServerError = hasError;
    this.isLoaded = true;
    this.isLoadingNextPage = false;
  }

  private handleSuggestionsError(error: any) {
    console.error('Error loading suggestions:', error);
    this.finishLoading(true);
  }

  openSLDetails(list) {
    window.open('/dashboard/suggestion-list-details/' + list.id, '_blank');
  }

  change(type) {
    this.updateTabState(type);
    this.resetAndReload();
  }

  private updateTabState(type: string) {
    if(type === 'create') {
      this.create = true;
      this.redirect = false;
    }
    if(type === 'redirect') {
      this.create = false;
      this.redirect = true;
    }
  }

  private resetAndReload() {
    this.currentPage = 0;
    this.mySLListActive = [];
    this.mySLListNotActive = [];
    this.loadSuggestions(0);
  }

  loadNextPage() {
    if (!this.isLoadingNextPage && this.hasNextPage()) {
      this.loadSuggestions(this.currentPage + 1);
    }
  }

  loadPreviousPage() {
    if (!this.isLoadingNextPage && this.currentPage) {
      this.loadSuggestions(this.currentPage - 1);
    }
  }

  loadNext5Pages() {
    if (!this.isLoadingNextPage) {
      const targetPage = Math.min(this.currentPage + 5, this.totalPages - 1);
      if (targetPage > this.currentPage) {
        this.loadSuggestions(targetPage);
      }
    }
  }

  loadPrevious5Pages() {
    if (!this.isLoadingNextPage) {
      const targetPage = Math.max(this.currentPage - 5, 0);
      if (targetPage < this.currentPage) {
        this.loadSuggestions(targetPage);
      }
    }
  }

  hasNextPage(): boolean {
    return this.currentPage < (this.totalPages - 1);
  }

  hasPreviousPage(): boolean {
    return this.currentPage > 0;
  }

  hasNext5Pages(): boolean {
    return this.currentPage + 5 < this.totalPages;
  }

  hasPrevious5Pages(): boolean {
    return this.currentPage >= 5;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/suggestion-lists/components/my-suggestion-lists/my-sl-tab/my-sl-tab.component.ts